import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { ClientSelectWithModal } from "@/components/ui/selects/components/ClientSelectWithModal";

interface ContactSelectorProps {
  control: any;
  isSubmitting: boolean;
}

export const ContactSelector: React.FC<ContactSelectorProps> = ({ control, isSubmitting }) => (
  <FormField
    control={control}
    name="contact_id"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Contact</FormLabel>
        <FormControl>
          <ClientSelectWithModal
            value={field.value || ""}
            onValueChange={(val: string) => field.onChange(val)}
            placeholder="Search or select a contact"
            fullWidth
          />
        </FormControl>
        <FormDescription>Select the contact this communication is for</FormDescription>
        <FormMessage />
      </FormItem>
    )}
  />
);
